import { render } from "./TheHeader.vue?vue&type=template&id=555dd9eb"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=555dd9eb&lang=scss"
script.render = render

export default script